var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loadingBalanceHistory)?_c('LoadingCard',{staticClass:"balance-history-loader",attrs:{"fullScreen":false}}):_vm._e(),(_vm.relevantHistoryData.series.length > 0)?_c('ApexCharts',{attrs:{"width":"100%","type":"line","options":_vm.chartOptions,"series":_vm.relevantHistoryData.series}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }